import { createSelector } from 'reselect';
import resolveRequest from '@clearscore/helpers.resolve-request';

const getActiveMarket = (state) => resolveRequest(state, 'market.activeMarket');
const getRoutesMarket = (state) => resolveRequest(state, 'routes.current');
const getFetchStatus = (state) => resolveRequest(state, 'market.fetchStatus');

export default createSelector(
    getActiveMarket,
    getRoutesMarket,
    getFetchStatus,
    (activeMarket, routesMarket, fetchStatus) => activeMarket === routesMarket && fetchStatus === 'success',
);
